(function () {
  // =========================
  // Utils
  // =========================
  function norm(s) {
    return String(s ?? "").trim();
  }

  function findFormFromTarget(el) {
    if (!el) return null;
    return el.form || document.getElementById(el.getAttribute("form"));
  }

  function getProductJsonNearForm(form) {
    if (!form) return null;

    var wrapper = form.closest('[id^="shopify-section-"]') || document;
    var el = wrapper.querySelector('script[id^="ProductJson-"][type="application/json"]');

    if (!el) el = document.querySelector('script[id^="ProductJson-"][type="application/json"]');
    if (!el) return null;

    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  // =========================
  // Variant selection
  // - 이 테마는 :checked 신뢰성이 흔들릴 수 있어 "방금 바뀐 라디오"를 우선 반영
  // - 다중 옵션 상품은: 같은 picker 범위에서 다른 option-index의 'checked'를 최대한 수집
  // =========================
  function buildSelectedOptions(product, changedRadio, form) {
    var count = (product.options || []).length;
    if (count === 0) return [];

    var opts = new Array(count).fill(null);

    // 1) 방금 바뀐 라디오 값은 확정
    var changedIdx = parseInt(changedRadio.getAttribute("data-option-index"), 10);
    if (!Number.isNaN(changedIdx) && changedIdx >= 0 && changedIdx < count) {
      opts[changedIdx] = norm(changedRadio.value);
    }

    // 2) 나머지 옵션 인덱스는 같은 섹션/폼 범위에서 checked 수집 시도
    // (테마가 checked를 관리하는 상품이면 자동으로 채워짐)
    var scope =
      (form && form.closest && form.closest('[id^="shopify-section-"]')) ||
      (changedRadio.closest && changedRadio.closest('[id^="shopify-section-"]')) ||
      document;

    for (var i = 0; i < count; i++) {
      if (opts[i] != null) continue;

      var checked = scope.querySelector(
        'input[type="radio"].js-variant-item[data-option-index="' + i + '"][checked]'
      );

      // 일부 테마는 checked 속성 대신 property만 바꾸므로 fallback도 한 번
      if (!checked) {
        var candidates = scope.querySelectorAll(
          'input[type="radio"].js-variant-item[data-option-index="' + i + '"]'
        );
        for (var k = 0; k < candidates.length; k++) {
          if (candidates[k].checked) {
            checked = candidates[k];
            break;
          }
        }
      }

      if (checked) opts[i] = norm(checked.value);
    }

    return opts;
  }

  function findVariant(product, selectedOptions) {
    if (!product || !product.variants) return null;

    if (!selectedOptions || selectedOptions.length === 0) {
      return product.variants[0] || null;
    }

    return (
      product.variants.find(function (v) {
        if (!v.options) return false;

        for (var i = 0; i < selectedOptions.length; i++) {
          if (selectedOptions[i] == null) return false;
          if (norm(v.options[i]) !== norm(selectedOptions[i])) return false;
        }
        return true;
      }) || null
    );
  }

  function setVariantIdEverywhere(variantId) {
    var inputs = document.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
    if (!inputs.length) return;

    inputs.forEach(function (idInput) {
      idInput.value = String(variantId);
      // 테마/앱에서 change를 듣는 경우가 많아서 유지
      idInput.dispatchEvent(new Event("change", { bubbles: true }));
      if (idInput.form) idInput.form.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  // =========================
  // Price update (KRW fixed format)
  // =========================
  function formatKRWFromCents(cents) {
    var n = Math.round(Number(cents) / 100); // 소수 방지
    var s = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return "₩" + s + " KRW";
  }

  function updatePrice(variant, form) {
    if (!variant) return;

    var scope = (form && form.closest && form.closest('[id^="shopify-section-"]')) || document;
    var wrapper =
      scope.querySelector('div[id^="productPrice-"]') ||
      document.querySelector('div[id^="productPrice-"]');

    if (!wrapper) {
      console.log("[variant-sync] STOP: price wrapper not found (div[id^=productPrice-])");
      return;
    }

    var priceText = formatKRWFromCents(variant.price);

    // 정가 영역
    var regularEl = wrapper.querySelector(".price-item--regular");
    if (regularEl) {
      regularEl.textContent = priceText;
    } else {
      console.log("[variant-sync] WARN: .price-item--regular not found");
    }

    // 세일 영역(있으면만)
    var saleEl = wrapper.querySelector(".price__sale .price-item--last");
    if (saleEl) saleEl.textContent = priceText;
  }

  // =========================
  // Main handler
  // =========================
  function handleRadio(radio) {
    if (!radio || !radio.matches || !radio.matches('input[type="radio"].js-variant-item')) return;

    var form = findFormFromTarget(radio);
    if (!form) {
      console.log("[variant-sync] STOP: form not found");
      return;
    }

    var product = getProductJsonNearForm(form);
    if (!product) {
      console.log("[variant-sync] STOP: product json not found");
      return;
    }

    var selectedOptions = buildSelectedOptions(product, radio, form);

    // 옵션이 여러 개인데 일부를 못 찾은 경우엔 여기서 멈춤(오동작 방지)
    if ((product.options || []).length > 1 && selectedOptions.some(function (v) { return v == null; })) {
      console.log("[variant-sync] STOP: selectedOptions incomplete:", selectedOptions);
      return;
    }

    var variant = findVariant(product, selectedOptions);
    if (!variant) {
      console.log("[variant-sync] STOP: variant not found:", selectedOptions);
      return;
    }

    console.log("[variant-sync] OK:", { options: selectedOptions, id: variant.id, price: variant.price });

    setVariantIdEverywhere(variant.id);
    updatePrice(variant, form);

    // 테마 트리거(있으면만)
    try {
      form.dispatchEvent(new CustomEvent("variant:change", { bubbles: true, detail: { variant: variant } }));
      document.dispatchEvent(new CustomEvent("variant:change", { detail: { variant: variant } }));
    } catch (e) {}
  }

  // =========================
  // Events
  // =========================
  document.addEventListener("change", function (e) {
    handleRadio(e.target);
  });

  // label 클릭만으로 change가 안 잡히는 케이스 대비
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t) return;

    // 라디오 직접 클릭
    if (t.matches && t.matches('input[type="radio"].js-variant-item')) {
      handleRadio(t);
      return;
    }

    // label 클릭 -> for로 라디오 찾기
    if (t.closest) {
      var label = t.closest("label");
      if (label && label.getAttribute("for")) {
        var maybe = document.getElementById(label.getAttribute("for"));
        if (maybe && maybe.matches && maybe.matches('input[type="radio"].js-variant-item')) {
          handleRadio(maybe);
        }
      }
    }
  });
})();
